import useAccountInfo from "@/hooks/useAccountInfo";
import { useClientFeature } from "@/hooks/useClientFeature";
import {
  resolveIntegrationAccess,
  type IntegrationAccess,
} from "@/utils/integrationAccess";

export function useIntegrationAccess(): IntegrationAccess {
  const { isFeatureEnabled } = useClientFeature();
  const accountInfo = useAccountInfo((state) => state.accountInfo);

  return resolveIntegrationAccess({
    hasFacebookConversionApi: isFeatureEnabled(
      "integrationFacebookConversionApi",
    ),
    hasLuda: isFeatureEnabled("luda"),
    hasOutboundWebhooks: isFeatureEnabled("outboundWebhooks"),
    hasPaymentTerminals: isFeatureEnabled("paymentTerminals"),
    isInternalAdmin: accountInfo.systemRole === "admin",
    isAccountAdmin: accountInfo.userTypeId === 4,
  });
}
